import {CustomFieldType} from '@frontapp/workflows/custom_fields';
import React, {FC} from 'react';

import {TeammateModel} from '../../../../libs/shared/core/src/models/api/teammateModel';
import {CustomAttributeModel} from '../../../models/api/customFieldModel';
import {CustomAttributeInboxContainer} from '../../contacts/contactInformation/customAttributeInboxContainer';
import {CustomAttributeTeammateContainer} from '../../contacts/contactInformation/customAttributeTeammateContainer';
import {InlineEditingBooleanPopover} from './inlineEditingBooleanPopover';
import {InlineEditingDateTimePickerContainer} from './inlineEditingDateTimePickerContainer';
import {InlineEditingEnumDropdown} from './inlineEditingEnumDropdown';
import {InlineEditingInboxPopover} from './inlineEditingInboxPopover';
import {InlineEditingNumberInputBox} from './inlineEditingNumberInputBox';
import {InlineEditingTeammatePopover} from './inlineEditingTeammatePopover';
import {InlineEditingTextBox} from './inlineEditingTextBox';

interface InlineEditingCustomAttributeProps {
  customAttribute: CustomAttributeModel;
  editedValue: string;
  onEdit: (arg: string) => void;
  onEditSave: (arg: string) => void;
  onEditCancel: () => void;
  shouldStartInEditMode?: boolean;
}

export const InlineEditingCustomAttribute: FC<InlineEditingCustomAttributeProps> = ({
  customAttribute,
  editedValue,
  onEdit,
  onEditSave,
  onEditCancel,
  shouldStartInEditMode,
}) => {
  const {customField} = customAttribute;

  switch (customField.type) {
    case CustomFieldType.STRING:
      return (
        <InlineEditingTextBox
          value={editedValue}
          onEdit={onEdit}
          onEditSave={onEditSave}
          onEditCancel={onEditCancel}
          shouldStartInEditMode={shouldStartInEditMode}
        />
      );

    case CustomFieldType.ENUM:
      return (
        <InlineEditingEnumDropdown
          value={editedValue}
          customField={customField}
          onEditSave={onEditSave}
          shouldStartInEditMode={shouldStartInEditMode}
        />
      );

    case CustomFieldType.DATETIME:
      return (
        <InlineEditingDateTimePickerContainer
          value={editedValue}
          onEdit={onEdit}
          onEditSave={onEditSave}
          selectedValue={customAttribute.value}
          shouldStartInEditMode={shouldStartInEditMode}
        />
      );

    case CustomFieldType.BOOLEAN:
      return (
        <InlineEditingBooleanPopover
          onEditSave={onEditSave}
          onEditCancel={onEditCancel}
          value={customAttribute.value}
          shouldStartInEditMode={shouldStartInEditMode}
        />
      );

    case CustomFieldType.NUMBER:
      return (
        <InlineEditingNumberInputBox
          value={editedValue}
          onEdit={onEdit}
          onEditSave={onEditSave}
          onEditCancel={onEditCancel}
          shouldStartInEditMode={shouldStartInEditMode}
        />
      );

    case CustomFieldType.TEAMMATE:
      return (
        <InlineEditingTeammatePopover
          onEditSave={(teammate: TeammateModel) => onEditSave(teammate.email)}
          onEditCancel={onEditCancel}
          teammateEmail={customAttribute.value}
          renderButtonContent={(teammateEmail: string) => (
            <CustomAttributeTeammateContainer teammateEmail={teammateEmail} />
          )}
          shouldStartInEditMode={shouldStartInEditMode}
        />
      );

    case CustomFieldType.INBOX:
      return (
        <InlineEditingInboxPopover
          onEditSave={onEditSave}
          onEditCancel={onEditCancel}
          inboxPublicId={customAttribute.value}
          renderButtonContent={(inboxPublicId: string) => (
            <CustomAttributeInboxContainer inboxPublicId={inboxPublicId} />
          )}
          shouldStartInEditMode={shouldStartInEditMode}
        />
      );

    case CustomFieldType.TEAMMATE_LIST: // TODO(laurentmeyer 2023-08-14): should not be used currently, to update once it is.
    default:
      return null;
  }
};
